/* ============================================================
   PIPLI DESIGN SYSTEM JS (pipli-ds.js)
   Scroll-reveal via IntersectionObserver. Reduced-motion safe.
   Add class "pp-reveal" to any element to fade/slide it in.
   Add "pp-stagger" to a parent to stagger its .pp-reveal children.
   ============================================================ */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.pp-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    // assign stagger index within each .pp-stagger group
    document.querySelectorAll('.pp-stagger').forEach(function (group) {
      group.querySelectorAll('.pp-reveal').forEach(function (el, i) {
        if (!el.style.getPropertyValue('--i')) el.style.setProperty('--i', i);
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);

  // Re-scan when Shopify theme editor adds/changes sections
  document.addEventListener('shopify:section:load', reveal);
})();
